import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { DateTimezoneService } from '@services/date-timezone.service';

@Pipe({ name: 'customDateByUtc' })
export class CustomDateByUtcPipe implements PipeTransform {
  constructor(private datePipe: DatePipe, private dateTimezoneService: DateTimezoneService) {}

  public transform(value: any, format: string = ''): string | null {
    if (!value) {
      return '';
    }

    if (!!format) {
      return this.datePipe.transform(value, format);
    }

    return this.datePipe.transform(
      this.dateTimezoneService.formatViewValueWithRemovalOfZones(value, 'MM/dd/yyyy', '+0000'),
      'MM/dd/yyyy',
      '+0000',
    );
  }
}
